var map = {
	"./00.png": 1165,
	"./01.png": 7268,
	"./02.png": 479,
	"./03.png": 7190,
	"./04.png": 7273,
	"./05.png": 9152,
	"./06.png": 7483,
	"./07.png": 6306
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1545;